// eslint-disable-line max-lines
import React, {Component} from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import {Form, Input, Select, Checkbox, Popup, Container} from 'semantic-ui-react';
import {enterKeyCode, tabKeyCode} from '../../../common/constants/keyCodes';
import {dateFormatPicker, reverseShortDate} from '../../../common/constants/datesFormat';
import {WARRANTIES_TYPES} from '../../constants';
import {Actions} from '../../../common/actions';
import TasksParts from './TasksPart';
import PrincipalPart from './PrincipalPart';
import WarrantyTabs from '../form/tabs';
import CampaignPart from './CampaignPart';
import Observations from './Observations';
import StatusPart from './StatusPart';
import './styles.scss';
import DatePickerReadOnlyInput from '../../../common/components/form/datePickerReadOnly';

const warrantyTypes = WARRANTIES_TYPES.filter((item) => item.text !== 'TODOS');

const Divisor = ({text, warranty}) => {
  return (
    <p className='warranty-divisor'>
      {text}
      {warranty && <span>Número de garantía {warranty}</span>}
    </p>
  );
};

class WarrantyAdminForm extends Component {
  handleCampaignState = () => {
    const {campaignFlag, handleChange, addMessageBoxError, campaignList, chassis, vehicle} = this.props;

    if (!campaignList.length && !campaignFlag && vehicle?.chassis === chassis) {
      addMessageBoxError(`Vehículo ${chassis} no se encuentra en campaña`);
      return;
    } else if (!campaignList.length && !campaignFlag) {
      addMessageBoxError(`Vehículo ${chassis} debe ser consultado`);
      return;
    }
    handleChange('campaignFlag', !campaignFlag);
  };

  handleChassis = (e, {value}) => {
    const {vehicle, handleChange, clearCampaignsList, clearWarrantyAdminChassis} = this.props;

    if (vehicle?.chassis && vehicle?.chassis !== value) {
      clearCampaignsList();
      clearWarrantyAdminChassis();
      handleChange('campaignFlag', false);
    }
    handleChange('chassis', value);
  };

  handleKeyDownKm = (e) => {
    const {chassis, km, stateTwc} = this.props;
    if (e.keyCode === enterKeyCode || e.keyCode === tabKeyCode) {
      this.props.checkChassisMileage(chassis, {km, stateTwc});
    }
  };

  showSuggestedSaleDatePopup = (salesDate, historicSalesDate) => {
    const salesDateNumber = moment(salesDate).format('x');
    const historicSalesDateNumber = moment(historicSalesDate).format('x');
    return salesDateNumber === historicSalesDateNumber;
  };

  render() {
    const {
      code, dealerEdit, twcWarrantyId, createDate, repairDate, type, dataId, previousDate, errorId,
      campaignFlag = false, processDate, openRepairDate, endRepairDate, condition, invalidKm,
      cause, repair, repairEn, conditionEn, causeEn, observationTDE, observationDealer,
      observationDealerEn, localOfp, twcAccountDefinitive, endDate, chassis, km, salesDate,
      stateTwc, principalPart, principalPartDescription, disabledBtns, loading, totalTwc,
      jobs, files, subcontracts, parts, vehicle, operationType, handleSearchPart, checking,
      handleChange, handleEvent, handleChangeType, handleKeyDownChassis, historicSalesDate,
      agency,
    } = this.props;
    const chassisError = {'content': 'Vehículo no corresponde a chassis consultado'};
    const kmError = {'content': 'Kilometraje inválido'};
    return (
      <div className='warranty-form-pd'>
        <Form>
          <Divisor text='Garantía & Vehículo' warranty={code} />
          <Form.Group widths='three'>
            <Form.Field
              disabled={true}
              value={code}
              control={Input}
              label='Garantía No.'
              placeholder='Codigo del Distribuidor'
            />
            <Form.Field
              disabled={true}
              value={twcWarrantyId}
              control={Input}
              label='Tipo de Garantía'
              placeholder='Tipo de Garantía'
            />
            <Form.Field
              disabled={true}
              value={agency}
              control={Input}
              label='Agencia'
              placeholder='Agencia'
            />
            <Form.Field>
              <div className='field'>
                <label>Campaña</label>
              </div>
              <Checkbox
                toggle={true}
                checked={campaignFlag}
                disabled={
                  disabledBtns ||
                  (!campaignFlag && vehicle?.chassis !== chassis)
                }
                onChange={this.handleCampaignState}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group widths='four'>
            <Form.Input fluid label='Fecha de Reclamo'>
              <DatePicker
                customInput={<DatePickerReadOnlyInput />}
                placeholderText='Fecha de Reclamo'
                className='tcc-datepicker'
                showYearDropdown
                selected={createDate ? moment(createDate).toDate() : null}
                disabled={loading || disabledBtns}
                dateFormat={dateFormatPicker}
                onChange={(value) => handleChange('createDate', value)}
                locale='es'
              />
            </Form.Input>
            <Form.Field
              disabled={disabledBtns}
              value={type}
              control={Select}
              options={warrantyTypes}
              label='Tipo TWC'
              placeholder='Tipo TWC'
              onChange={(e, {value}) => handleChangeType('type', value)}
            />
            <Form.Field
              disabled={disabledBtns}
              value={dataId}
              control={Input}
              label='Data ID'
              maxLength='10'
              placeholder='Data ID'
              onChange={(e, {value}) => handleChange('dataId', value)}
            />
            <Form.Input fluid label='Fecha Fact Anterior'>
              <DatePicker
                customInput={<DatePickerReadOnlyInput />}
                disabled={disabledBtns}
                placeholderText='Fecha Fact Anterior'
                className='tcc-datepicker'
                showYearDropdown
                selected={previousDate ? moment(previousDate).toDate() : null}
                dateFormat={dateFormatPicker}
                onChange={(value) => handleChange('previousDate', value)}
                locale='es'
              />
            </Form.Input>
          </Form.Group>
          <Divisor text='Observaciones' />

          <Observations
            disabledBtns={disabledBtns}
            handleChange={handleChange}
            condition={condition}
            cause={cause}
            repair={repair}
            repairEn={repairEn}
            conditionEn={conditionEn}
            causeEn={causeEn}
            handleEvent={handleEvent}
          />

          <Divisor text='Tareas' />
          <TasksParts {...this.props} />

          <Divisor text='Comentarios' />
          <Form.TextArea
            maxLength='200'
            disabled={disabledBtns}
            label='Obs. para dealer'
            placeholder='Obs. para dealer'
            value={observationDealer || ''}
            onChange={(e, {value}) =>
              handleChange('observationDealer', value)
            }
          />
          <Form.TextArea
            maxLength='200'
            disabled={disabledBtns}
            label='Comentarios dist.'
            placeholder='Comentarios dist.'
            value={observationTDE || ''}
            onChange={(e, {value}) => handleChange('observationTDE', value)}
          />
          <Form.TextArea
            maxLength='200'
            disabled={disabledBtns}
            label='Dist. comment'
            placeholder='Dist. comment'
            value={observationDealerEn || ''}
            onChange={(e, {value}) =>
              handleChange('observationDealerEn', value)
            }
          />
          <WarrantyTabs
            stateTwc={stateTwc}
            disabledBtns={disabledBtns}
            totalTwc={totalTwc}
            handleChangeForm={handleChange}
            jobs={jobs}
            files={files}
            subcontracts={subcontracts}
            parts={parts}
            campaignFlag={campaignFlag}
            code={code}
            type={type}
            dealerEdit={dealerEdit}
          />
          <PrincipalPart
            disabledBtns={disabledBtns}
            handleSearchPart={handleSearchPart}
            handleChange={handleChange}
            principalPart={principalPart}
            principalPartDescription={principalPartDescription}
            operationType={operationType}
          />

          <Form.Group widths='three'>
            <Form.Field
              disabled={disabledBtns}
              value={localOfp || ''}
              maxLength={1}
              control={Input}
              label='Local'
              placeholder='Local'
              onChange={(e, {value}) => handleChange('localOfp', value)}
            />
            <Form.Field
              disabled={true}
              value={twcAccountDefinitive || ''}
              control={Input}
              label='Cuenta de Cobro Definitiva'
              placeholder='Cuenta de Cobro Definitiva'
            />
            <Form.Input fluid label='Fecha de Cierre'>
              <DatePicker
                customInput={<DatePickerReadOnlyInput />}
                placeholderText='Fecha de Cierre'
                className='tcc-datepicker'
                showYearDropdown
                selected={endDate ? moment(endDate).toDate() : null}
                disabled={loading || disabledBtns}
                dateFormat={dateFormatPicker}
                onChange={(value) => handleChange('endDate', value)}
                locale='es'
              />
            </Form.Input>
          </Form.Group>
          <Form.Group widths='three'>
            <Form.Input fluid label='Fecha de venta del vehículo'>
              <Popup content={`La fecha original de venta es ${moment(historicSalesDate).format(reverseShortDate)}`}
                disabled={this.showSuggestedSaleDatePopup(salesDate, historicSalesDate)}
                trigger={
                  <Container fluid style={{'margin': '0'}}>
                    <DatePicker
                      customInput={<DatePickerReadOnlyInput
                        customClass={this.showSuggestedSaleDatePopup(salesDate, historicSalesDate) ?
                          '' : 'suggestedDateInputBorder'} />}
                      placeholderText='Fecha de venta del vehículo'
                      className='tcc-datepicker'
                      showYearDropdown
                      selected={salesDate ? moment(salesDate).toDate() : null}
                      disabled={loading || disabledBtns}
                      dateFormat={dateFormatPicker}
                      onChange={(value) => handleChange('salesDate', value)}
                      locale='es'
                    />
                  </Container>
                }>
              </Popup>
            </Form.Input>
            <Form.Field
              disabled={disabledBtns}
              value={km}
              type='number'
              min='0'
              error={invalidKm && kmError}
              onKeyDown={this.handleKeyDownKm}
              control={Input}
              loading={checking}
              label='Kilometraje'
              placeholder='Kilometraje'
              onChange={(e, {value}) => handleChange('km', value)}
            />
            <Form.Input fluid label='Fecha de Reparación'>
              <DatePicker
                customInput={<DatePickerReadOnlyInput />}
                disabled={disabledBtns}
                placeholderText='Fecha de Reparación'
                className='tcc-datepicker'
                showYearDropdown
                selected={repairDate ? moment(repairDate).toDate() : null}
                dateFormat={dateFormatPicker}
                onChange={(value) => handleChange('repairDate', value)}
                locale='es'
              />
            </Form.Input>
          </Form.Group>
          <Form.Group widths='three'>
            <Form.Input fluid label='Fecha de Proceso Inicial'>
              <DatePicker
                customInput={<DatePickerReadOnlyInput />}
                placeholderText='Fecha de Proceso Inicial'
                className='tcc-datepicker'
                showYearDropdown
                selected={processDate ? moment(processDate).toDate() : null}
                disabled={disabledBtns}
                dateFormat={dateFormatPicker}
                onChange={(value) => handleChange('processDate', value)}
                locale='es'
              />
            </Form.Input>
            <Form.Input fluid label='Fecha de Apertura de Reparación'>
              <DatePicker
                customInput={<DatePickerReadOnlyInput />}
                placeholderText='Fecha de Apertura de Reparación'
                className='tcc-datepicker'
                showYearDropdown
                selected={
                  openRepairDate ? moment(openRepairDate).toDate() : null
                }
                disabled={disabledBtns}
                dateFormat={dateFormatPicker}
                onChange={(value) => handleChange('openRepairDate', value)}
                locale='es'
              />
            </Form.Input>
            <Form.Input fluid label='Fecha de Finalización de la Reparación'>
              <DatePicker
                customInput={<DatePickerReadOnlyInput />}
                placeholderText='Fecha de Finalización de la Reparación'
                className='tcc-datepicker'
                showYearDropdown
                selected={endRepairDate ? moment(endRepairDate).toDate() : null}
                disabled={disabledBtns}
                dateFormat={dateFormatPicker}
                onChange={(value) => handleChange('endRepairDate', value)}
                locale='es'
              />
            </Form.Input>
          </Form.Group>
          <Form.Group widths='three'>
            <StatusPart
              stateTwc={stateTwc}
              errorId={errorId}
              handleChange={handleChange}
            />
            <Form.Field
              value={chassis}
              control={Input}
              label='VIN Chasis'
              placeholder='Chasis'
              minLength='10'
              maxLength='18'
              disabled={loading || disabledBtns}
              error={vehicle?.chassis !== chassis && chassisError}
              onKeyDown={handleKeyDownChassis}
              onChange={this.handleChassis}
            />
          </Form.Group>
          <CampaignPart {...this.props} />
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {loading, loadingStatus, loadingCause, loadingCondition, loadingRepair} = state.warrantyAdmin;
  const loadingWarranty = loading || loadingStatus || loadingCause || loadingCondition || loadingRepair;
  return {
    'dealerId': state.session.dealerId,
    'warranty': state.warrantyAdmin.warranty,
    'loading': loadingWarranty,
    'warrantyStatus': state.warrantyAdmin.warrantyStatus,
    'conditionList': state.warrantyAdmin.conditionList,
    'causeList': state.warrantyAdmin.causeList,
    'repairList': state.warrantyAdmin.repairList,
    'part': state.warrantiesAdminCategories.part,
    'campaignList': state.campaignList.list,
    'vehicle': state.warrantyAdminVehicle.vehicle,
    'checking': state.updateWarrantyAdmin.checking,
  };
};

const {addMessageBoxError, checkChassisMileage, clearCampaignsList, clearWarrantyAdminChassis} =
  Actions;

export default connect(mapStateToProps, {
  checkChassisMileage,
  addMessageBoxError,
  clearCampaignsList,
  clearWarrantyAdminChassis,
})(WarrantyAdminForm);
